import { render, staticRenderFns } from "./GrantPage.vue?vue&type=template&id=5cf5cb2f&scoped=true"
import script from "./GrantPage.vue?vue&type=script&lang=js"
export * from "./GrantPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf5cb2f",
  null
  
)

export default component.exports